import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { useState } from "react";
import { AuthRedirector } from "@/components/AuthRedirector";
import { AuthProvider } from "@/components/AuthProvider";
import ScrollToTop from "@/components/ScrollToTop";
import { SeoRouteSync } from "@/components/seo/SeoRouteSync";
import { StructuredDataSync } from "@/components/seo/StructuredDataSync";
import { BackendPrewarmSync } from "@/components/common/BackendPrewarmSync";
import { AuthModal } from "@/components/auth/AuthModal";
import AppRoutes from "@/routes/AppRoutes";

const queryClient = new QueryClient();

function App() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<"login" | "register">("login");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [showQuickRideModal, setShowQuickRideModal] = useState(false);

  const handleAuthClick = (mode: "login" | "register") => {
    setAuthMode(mode);
    setShowAuthModal(true);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <AuthRedirector />
            <ScrollToTop />
            <SeoRouteSync />
            <StructuredDataSync />
            <BackendPrewarmSync />
            <AppRoutes
              showAuthModal={showAuthModal}
              setShowAuthModal={setShowAuthModal}
              authMode={authMode}
              setAuthMode={setAuthMode}
              showQuickRideModal={showQuickRideModal}
              setShowQuickRideModal={setShowQuickRideModal}
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
              handleAuthClick={handleAuthClick}
            />
            {/* Render after routes so auth stacks above page dialogs (e.g. Save for later). */}
            {showAuthModal && (
              <AuthModal
                mode={authMode}
                onClose={() => setShowAuthModal(false)}
                onSwitchMode={setAuthMode}
              />
            )}
          </Router>
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
